export const permissions: string[] = ['public_profile', 'email'];
